<template>
    <div  :style="{...styles.base,padding:'0 0.03rem'}" >
      <bind-phone-h
          v-if="deviceMode=== 'h5'"
          :configurationData="configurationData"
          :styles="styles"
          :intervalDataFetchList="intervalDataFetchList"
          :events="events"
          :production="production"
      />
      <bind-phone-pc
          v-if="deviceMode=== 'pc'"
          :configurationData="configurationData"
          :styles="styles"
          :intervalDataFetchList="intervalDataFetchList"
          :events="events"
          :production="production"
      />
    </div>
</template>

<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import BindPhonePc from './bind-phone-pc.vue';
import BindPhoneH from './bind-phone-h.vue';

export default {
  name: 'CSupercoreUserBindPhone',
  components: {
    BindPhonePc, BindPhoneH,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 's-super-bind-phone-style-',
      isMobile: null,
    };
  },
  computed: {},
  methods: {
  },
};
</script>

<style lang="scss">
// @import './styles.scss';
</style>
